import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT = {
  address_line: "C/ del Taller, 12 · León, España",
  web_line: "esmaltealfuegoguerrero.com",
  email: "hola@esmaltealfuegoguerrero.com",
  phone: "",
  map_lat: 42.598,
  map_lng: -5.568,
};

const SettingsContext = createContext(DEFAULT);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT);

  useEffect(() => {
    api.get("/admin/settings/public")
      .then((r) => setSettings({ ...DEFAULT, ...r.data }))
      .catch(() => {}); // silently fall back to defaults
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
